<template>
    <v-card class="frame text-xs-center">
        <v-card-text style="background-color: #0038A8" class="headline  white--text sella">
            <span class="info--text font-weight-bold">{{calcRata.numeroRate}} rate mensili</span>
        </v-card-text>
        <v-card-text class="headline font-weight-bold">{{formattedValues(calcRata.importoRata)}}&euro;/mese
        </v-card-text>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1>
                <v-divider></v-divider>
            </v-flex>
        </v-layout>
        <v-card-text class="">TAN FISSO {{formattedValues(calcRata.tan)}}&percnt;</v-card-text>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1>
                <v-divider></v-divider>
            </v-flex>
        </v-layout>
        <v-card-text class=""><span class="font-weight-bold">TAEG {{formattedValues(calcRata.taeg)}}</span>&percnt;
        </v-card-text>
        <v-layout>
            <v-flex xs12 sm10 offset-sm1>
                <v-divider></v-divider>
            </v-flex>
        </v-layout>
        <v-card-actions style="position: absolute; bottom: 0px; left: 0px; right: 0px">
            <v-btn block color="info" class="primary--text" round
                   v-on:click="nuovaRichiesta(calcRata.numeroRate, importo, config.tabellaFinanziaria)">Richiedi ora!
            </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        props: {
            calcRata: {
                type: Object,
                default() {
                    return {}
                }
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            },
            importo: {
                type: Number,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },
        methods: {
            nuovaRichiesta: (rate, importo, tab) => {
                var vars = {};
                var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                    vars[key] = value;
                });
                window.location.href = `${process.env.VUE_APP_SITE_URL}/econsel/public/entry/pp?importo=${importo}&tabFin=${tab}&num_rate=${rate}&h_prod=88&${vars.utm_content}&${vars.utm_medium}&${vars.utm_campaign}&${vars.utm_source}`
            },
            formattedValues: function (val) {
                val = val.toFixed(2);
                return val;
            }
        }
    };
</script>

<style scoped>
    .frame {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: white;
    }

    .right {
        float: right;
    }

    .sellaStencil {
        font-family: "Sella Stencil" !important;
    }

    .sella {
        font-family: 'Sella';
    }

</style>
